import axios from 'axios';
import { getAuthToken, logout } from './authService';
import { API_BASE_URL } from '../config';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    config.headers = config.headers || {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
    if (!isFormData && config.method && config.method.toLowerCase() !== 'get' && !config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    if (status === 401 && typeof code === 'string' && code.startsWith('AUTH_')) {
      const reason = code === 'AUTH_SESSION_IDLE_TIMEOUT' ? 'idle_timeout' : 'session_invalid';
      await logout({ server: false, reason });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;